export default "__VITE_ASSET__BZvJ1GwN__"